import React, { useState, useEffect } from "react";

import Highcharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";
import { useVsiAppContext } from "../stores/VsiApp";
import styles from "../utils/themeStyles";
import { genericColors } from "../utils/chartUtils";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

require("highcharts/indicators/indicators")(Highcharts);
require("highcharts/indicators/pivot-points")(Highcharts);
require("highcharts/indicators/macd")(Highcharts);
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/map")(Highcharts);


function VsiSimpleGauge({ series, data, includeLegend, title = "", height }) {
	const { theme, isTabletScreen } = useVsiAppContext();
	const basicTextStyle = {
		color: styles[theme].textColor,
		fontFamily: styles[theme].fontFamily,
	};
	
	const updateSeries = (series, data) => {
		if (series) return series;
		else if (data)
			return [
				{
					data,
				},
			];
		return [];
	};
	
	const [chartOptions, setChartOptions] = useState(
		{
			colors: genericColors,
			mapNavigation: {
				enabled: false
			},
			navigator: {
				enabled: false
			},
			chart: {
				backgroundColor: 'transparent' || styles[theme].cardBgColor,
				color: styles[theme].textColor,
				plotBorderWidth: 0,
				plotShadow: false,
				type: 'pie',
				height: height || 300,
				spacing: [0, 0, 25, 0],
			},
			credits: {
				enabled: false,
			},
			title: {
				text: title,
				style: {
					...basicTextStyle,
					fontSize: '3rem',
				},
				align: 'center',
				verticalAlign: 'middle',
				y: 100,
				// verticalAlign: 'middle',
			},
			tooltip: {
				pointFormat: '{series.name} <b>{point.percentage:.1f}</b> <br/> <b>{point.y}</b>',
				formatter: function () {
					if (this.key === "N/A" || !this.key) {
						return false;
					}
					return `${this.key}: <b>${this.y}</b>`;
				},
				backgroundColor: styles[theme].altBgColor,
				style: basicTextStyle,
			},
			accessibility: {
				point: {
					valueSuffix: '%'
				}
			},
			plotOptions: {
				pie: {
					allowPointSelect: true,
					cursor: 'pointer',
					borderWidth: 2,
					dataLabels: {
						distance: 5,
						position: 'right',
						enabled: false,
						format: '{point.name}',
						connectorWidth: 0,
					},
					showInLegend: true,
					startAngle: -135,
					endAngle: 135,
					center: ['50%', '75%'],
					size: '110%'
				}
			},
			legend: {
				itemStyle: basicTextStyle,
				align: "center",
				enabled: includeLegend ? true : false
			},
			series: updateSeries(series, data),
		});
	
	useEffect(() => {
		setChartOptions(() => {
			return {
				...chartOptions,
				chart: {
					...chartOptions.chart,
					backgroundColor: 'transparent' || styles[theme].cardBgColor,
					color: styles[theme].textColor,
					height: height || 300,
				},
				tooltip: {
					...chartOptions.tooltip,
					backgroundColor: styles[theme].altBgColor,
					style: basicTextStyle,
				},
				title: {
					...chartOptions.title,
					text: title,
					style: {
						...basicTextStyle,
						fontSize: '3rem',
					},
				},
				legend: {
					...chartOptions.legend,
					itemStyle: basicTextStyle,
					align: "center"
				},
				series: updateSeries(series, data)
			}
		})
	}, [theme, isTabletScreen, series]);
	
	return <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
}

VsiSimpleGauge.displayName = "VsiSimpleGauge"

export default withErrorBoundary(VsiSimpleGauge, GeneralErrorBoundary);
